import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import {
  Feature1,
  Feature2,
  Feature3,
  Feature4,
  Feature5,
  Feature6,
  Feature7,
  Feature8,
  Feature9,
} from "../../../../app-constants";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 1600 },
    items: 6,
  },
  desktop: {
    breakpoint: { max: 1599, min: 1400 },
    items: 6,
  },
  tabletlandscape: {
    breakpoint: { max: 1399, min: 1200 },
    items: 5,
  },
  tablet: {
    breakpoint: { max: 1199, min: 667 },
    items: 4,
  },
  mobile: {
    breakpoint: { max: 666, min: 0 },
    items: 2,
  },
};

function FeatureNew(props) {
  return (
    <div className="feature_sec dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={3} lg={2} xl={2} xxl={2} className="my-auto">
            <h4>Featured by:</h4>
          </Col>
          <Col xs={12} md={9} lg={10} xl={10} xxl={10} className="my-auto">
            <Carousel
              responsive={responsive}
              infinite={true}
              autoPlay={true}
              autoPlaySpeed={3000}
              arrows={false}
              className="carousel_featured_new"
            >
              <div className="featured_item">
                <div className="featured_img">{Feature2}</div>
              </div>
              <div className="featured_item">
                <div className="featured_img">{Feature1}</div>
              </div>
              <div className="featured_item">
                <div className="featured_img">{Feature3}</div>
              </div>
              <div className="featured_item">
                <div className="featured_img">{Feature4}</div>
              </div>
              <div className="featured_item">
                <div className="featured_img">{Feature5}</div>
              </div>
              <div className="featured_item">
                <div className="featured_img">{Feature6}</div>
              </div>
              <div className="featured_item">
                <div className="featured_img">{Feature7}</div>
              </div>
              <div className="featured_item">
                <div className="featured_img">{Feature8}</div>
              </div>
              
            </Carousel>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FeatureNew;
